<template>
    <section class="grid justify-center mb-4 mt-1" >
        <div class="flex items-center justify-end pb-2" :disabled="formDisabled">
            <label for="description" class="mr-2">Descripción</label>
            <InputText id="description" v-model="description" placeholder="Descripción del gasto" class="w-80" :disabled="formDisabled"/>
        </div>
        <div class="flex items-center justify-end pb-2">
            <label for="subtotal">Subtotal</label>
            <InputNumber id="subtotal" v-model="subtotal" placeholder="0.00" class="ml-2 w-80" currency="MXN" locale="es-MX" :maxFractionDigits="2" :disabled="formDisabled"/>
        </div>
        <div class="flex items-center justify-end pb-2">
            <label for="iva">IVA</label>
            <InputNumber id="iva" v-model="iva" placeholder="0.00" class="ml-2 w-80" currency="MXN" locale="es-MX" :maxFractionDigits="2" :disabled="formDisabled"/>
        </div>
        <div class="flex items-center justify-end pb-2">
            <label for="issue-date">Fecha de emisión</label>
            <Calendar id="issue-date" v-model="issueDate" showIcon :showOnFocus="false" class="ml-2 w-80" dateFormat="dd/mm/yy" :disabled="formDisabled"/>
        </div>
        <div class="flex items-center justify-end pb-2">
            <label for="mark-paid" class="mr-2">Marcar pagado</label>
            <ToggleButton id="mark-paid" v-model="isPaid" onIcon="pi pi-check" offIcon="pi pi-times" onLabel="Sí"
                aria-label="Marcar pagado" class="w-80" :disabled="formDisabled"/>
        </div>
        <div class="flex items-center justify-end pb-2" v-if="isPaid">
            <label for="paid-date">Fecha de pago</label>
            <Calendar id="paid-date" v-model="paidDate" showIcon :showOnFocus="false" class="ml-2 w-80" dateFormat="dd/mm/yy" :disabled="formDisabled"/>
        </div>
        <div class="flex items-center justify-end pb-2" v-if="isPaid">
            <label for="paid-bank">Banco utilizado</label>
            <Dropdown id="paid-bank" v-model="paidBank" :options="banks" optionLabel="name" placeholder="Selecciona un banco" class="ml-2 w-80" :disabled="formDisabled">
                <template #value="slotProps">
                    <div v-if="slotProps.value" class="flex align-items-center">
                        <img :alt="slotProps.value.name" :src="slotProps.value.image" class="mr-2" style="width: 18px; height: 18px;" />
                        <div>{{ slotProps.value.name }}</div>
                    </div>
                    <span v-else>
                        {{ slotProps.placeholder }}
                    </span>
                </template>
                <template #option="slotProps">
                    <div class="flex align-items-center">
                        <img :alt="slotProps.option.name" :src="slotProps.option.image" class="mr-2" style="width: 18px; height: 18px;" />
                        <div>{{ slotProps.option.name }}</div>
                    </div>
                </template>
            </Dropdown>
        </div>
        <div class="flex items-center justify-end pb-2">
            <label for="company">Empresa</label>
            <Dropdown id="company" v-model="selectedCompany" :options="companies" optionLabel="name" placeholder="Selecciona una empresa" class="ml-2 w-80"
            @change="companyChange" :disabled="formDisabled"/>
        </div>
        <div class="flex items-center justify-end pb-2">
            <label for="branch">Sucursal</label>
            <Dropdown id="branch" v-model="selectedBranch" :options="selectedCompany.branches" optionLabel="name" placeholder="Selecciona una sucursal"
            class="ml-2 w-80" :disabled="formDisabled" filter/>
        </div>
        <div class="flex items-center justify-end pb-2">
            <label for="department">Departamento</label>
            <Dropdown id="department" v-model="selectedDepartment" :options="departments" optionLabel="name" placeholder="Selecciona un departamento"
            class="ml-2 w-80" :disabled="formDisabled"/>
        </div>
        <div class="flex items-center justify-end pb-2">
            <label for="category">Categoría</label>
            <Dropdown id="category" v-model="selectedCategory" :options="categories" optionLabel="name" placeholder="Selecciona una categoría"
            class="ml-2 w-80" :disabled="formDisabled" filter/>
        </div>
        <div class="mt-2">
            <Button id="record-btn" label="Registrar" @click="recordExpense" :disabled="buttonDisabled"></Button>
        </div>
    </section>
</template>

<script>
    import axiosInstance from '../axiosInstance';
    export default {
        data() {
            return {
                description: "",
                subtotal: null,
                iva: null,
                issueDate: new Date(),
                isPaid: false,
                paidDate: new Date(),
                selectedCompany: {},
                selectedBranch: {},
                selectedDepartment: {},
                selectedCategory: {},
                companies: [],
                departments: [],
                categories: [],
                banks: [],
                paidBank: {},
                formDisabled: false,
                buttonDisabled: false
            }
        },
        methods: {
            async fetchInitialData() {
                this.$emit("update-loading", true);
                this.formDisabled = true;
                this.buttonDisabled = true;
                let data = {};
                try {
                    const finances = axiosInstance.post("/api/expense_get", {
                        token: localStorage.getItem('token')
                    });

                    data = await finances;
            
                } catch(error) {
                    console.error("fetchInitialData: There was an error!", error);
                    this.$toast.add({ severity: 'error', summary: 'Error',
                    detail: 'Hubo un problema al consultar los datos.', life: 5000, group: 'topr' });
                } finally {
                    this.$emit("update-loading", false);
                }

                return data;
            },

            setInitialData() {
                this.fetchInitialData().then((response) => {
                    if(response.status === 200) {
                        const { defaultCmp, companies, departments, expense_categories: categories, banks } = response.data;
                        
                        this.selectedCompany = {
                            name: defaultCmp.data.name, 
                            id: defaultCmp.data.id, 
                            branches: defaultCmp.branches
                        }

                        this.companies = companies.map((company) => {
                            return {
                                name: company.data.name,
                                id: company.data.id,
                                branches: company.branches
                            }
                        });

                        this.banks = banks;
                        this.paidBank = this.banks[0];
                        this.selectedBranch = this.selectedCompany.branches[0];
                        this.departments = departments;
                        this.selectedDepartment = this.departments[0];
                        this.categories = categories;
                        this.selectedCategory = this.categories[0];

                        this.formDisabled = false;
                        this.buttonDisabled = false;
                    } else {
                        console.warn("setInitialData: There was a problem with the request.", response);
                        this.$toast.add({ severity: 'warn', summary: 'Aviso',
                        detail: 'Hubo un problema con la solicitud. Vuelve a intentarlo.', life: 5000, group: 'topr' });
                    }
                })
            },

            async postExpense() {
                this.$emit("update-loading", true);
                this.buttonDisabled = true;
                let data = {};
                try {
                    const request = {
                        description: this.description.trim(),
                        amount: this.subtotal === null ? 0 : this.subtotal,
                        tax: this.iva === null ? 0 : this.iva,
                        spent_at: this.formatDate(this.issueDate),
                        paid: "paid",
                        company_id: this.selectedCompany.id,
                        branch_id: this.selectedBranch.id,
                        department: this.selectedDepartment.id,
                        expense_category_id: this.selectedCategory.id,
                        token: localStorage.getItem('token')
                    };

                    if(this.isPaid){
                        request.paid_at = this.formatDate(this.paidDate);
                        request.bank_id = this.paidBank.id;
                    }

                    const response = axiosInstance.post("/api/expense_save", request);

                    data = await response;
            
                } catch(error) {
                    console.error("postExpense: There was an error!", error);
                    this.$toast.add({ severity: 'error', summary: 'Error',
                    detail: 'Hubo un problema al consultar los datos.', life: 5000, group: 'topr' });
                } finally {
                    this.$emit("update-loading", false);
                    this.buttonDisabled = false;
                }

                return data;
            },

            recordExpense() {
                this.postExpense().then((response) => {
                    if(response.status === 200) {
                        if(response.data.error && response.data.message) {
                            const { message } = response.data;
                            this.$toast.add({ severity: 'warn', summary: 'Aviso',
                            detail: message, life: 5000, group: 'topr' });
                        } else {
                            this.$toast.add({ severity: 'success', summary: 'Éxito',
                            detail: 'Gasto registrado correctamente.', life: 5000, group: 'topr' });
                            this.$router.push('/ver-gastos');
                        }
                    } else {
                        console.warn("recordExpense: There was a problem with the request.", response);
                        this.$toast.add({ severity: 'warn', summary: 'Aviso',
                        detail: 'Hubo un problema con la solicitud. Vuelve a intentarlo.', life: 5000, group: 'topr' });
                    }
                });
            },

            companyChange(){
                this.selectedBranch = this.selectedCompany.branches[0];
            },

            /**
             * Format a Date object to a string in format YYYY-MM-DD
             * @param date - Date object
             * @returns formatted date string
             */
            formatDate(date){
                const month = ((date.getMonth()+1).toString()).padStart(2, "0");
                const day = ((date.getDate()).toString()).padStart(2, "0");
                return `${date.getFullYear()}-${month}-${day}`
            },
        },

        mounted() {
            this.setInitialData();
        }
    }
</script>

<style scoped>
    ::v-deep(.p-calendar .p-button) {
        @apply bg-zinc-200 text-zinc-900 border-zinc-300 hover:bg-zinc-300 dark:bg-zinc-700 dark:text-zinc-100 dark:border-zinc-600 dark:hover:bg-zinc-600 transition-colors;
    }
    ::v-deep(.p-calendar .p-button:hover) {
        @apply bg-zinc-300 dark:bg-zinc-600;
    }
    ::v-deep(.p-highlight) {
        @apply bg-zinc-300 !important;
    }
    ::v-deep(.p-highlight:hover) {
        @apply bg-zinc-400 !important;
    }

    #record-btn {
        @apply bg-zinc-200 text-zinc-900 border border-zinc-300 hover:bg-zinc-300 dark:bg-zinc-700 dark:text-zinc-100 dark:border-zinc-600 dark:hover:bg-zinc-600 rounded px-4 py-2 text-lg shadow focus:outline-none transition-colors;
    }
</style>

<style>
/* Record button - light mode */
html:not(.dark) #record-btn {
    background-color: #0f1338 !important;
    border-color: #0f1338 !important;
    color: white !important;
}

html:not(.dark) #record-btn:hover:not(:disabled) {
    background-color: #1a1f4d !important;
    border-color: #1a1f4d !important;
}

/* Record button - dark mode */
html.dark #record-btn {
    background-color: #D9D9D9 !important;
    border-color: #D9D9D9 !important;
    color: #0f1338 !important;
}

html.dark #record-btn:hover:not(:disabled) {
    background-color: #c4c4c4 !important;
    border-color: #c4c4c4 !important;
}
</style>